exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_contentOrganizerPanel_wkoPJ82NC1-76oIUP0c1W {\n  padding: 40px;\n}", ""]);

// Exports
exports.locals = {
	"IA_contentOrganizerPanel": "IA_contentOrganizerPanel_wkoPJ82NC1-76oIUP0c1W"
};